import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Home from "./Pages/Home.jsx"

function App() {
  return (
< >
<Navbar />
<Home />
</>
  );
}

export default App;
